// extracted by mini-css-extract-plugin
export default {"errorsCountContainer":"errorsCountContainer__x9mSP","errorsTableContainer":"errorsTableContainer__sk05g","exclamation":"exclamation__MqMZM"};